/*
 * Copyright (c) 2023 SGS Europe. All rights reserved.
 *
 * This program is the CONFIDENTIAL and PROPRIETARY property of SGS Europe.
 * Any unauthorised use, reproduction, or transfer of this program is strictly
 * prohibited.
 *
 * File Name: Archive.js
 *
 * Description:	Functionality relating to files that are not ready for viewing.
 * 
 */

var g_oArchive = {

	// The current archive id.
	g_ArchiveDocument: 0,

	// If the current document is a comparison document.
	g_ArchiveCompareDocument: false,

	// The archive poll interval.
	g_ArchivePollInterval: 3000,

	// Globals.
	g_ArchiveIcons: {
		Pending: "img/Lock_wht_16.png",
		InProgress: "img/cog_icon_wht_24.png",
		Complete: "img/bubble_emblem-default24.png"
	},

	// The archived document status.
	g_ArchivedDocumentStatus: 6,

	/**
	 * Initialises the archive module.
	 * @param {int} archiveDocumentId - The id of the archive document.
	 */
	initialiseArchiveModule: function (archiveDocumentId, archiveCompareDocument) {
		
		// Get the document we are in the archive process for.
		g_oArchive.g_ArchiveDocument = archiveDocumentId;

		// Get the archive compare document setting.
		g_oArchive.g_ArchiveCompareDocument = archiveCompareDocument;

		// Lock the screen.
		g_oArchive.applyArchiveLock();

		// Restore the document.
		g_oArchive.restoreDocument();

		// Poll the archive status.
		g_oArchive.pollArchiveStatus();
	},

	/**
	 * Applies the archive lock.
	 */
	applyArchiveLock: function () {
		
		// Lock the screen.
		lockScreen();

		// Show the spinner message.
		showSpinnerMessage("Restoring Document");

		// Show the archive info.
		g_oArchive.showArchiveInfo();

		// Update the combo control lock settings.
		comboControl_UpdateAboveLock(comboControl_GetControlById(g_oArchive.getArchiveControlId(), true));
	},

	/**
	 * Removes the archive lock.
	 */
	removeArchiveLock: function () {
		
		// Reset the archive lock.
		g_oArchive.g_ArchiveDocument = 0;

		// Remove the archive info.
		g_oGreenlightMessages.closeBubbles("Info");

		// Remove the spinner message.
		hideSpinnerMessage();

		// Unlock the screen.
		unlockScreen();

		// Update the combo control lock settings.
		comboControl_UpdateAboveLock(comboControl_GetControlById(g_oArchive.getArchiveControlId(), true));
	},

	/**
	 * Shows the archive info.
	 */
	showArchiveInfo: function() {

		// Show the archive info bubble.
		g_oGreenlightMessages.displayInfoBubble(
			'<div class="speechbubble__paragraph speechbubble__paragraph--large">' + 'Archived Document' + '</div>' +
			'<div class="speechbubble__paragraph speechbubble__paragraph--large">' + 'This document has been archived. We are restoring the document and it will soon be available for use.' + '</div>' +
			'<div class="speechbubble__paragraph speechbubble__paragraph--large">' + 'Please either check back soon, or follow the process below.' + '</div>' +
			'<div class="speechbubble__paragraph speechbubble__paragraph--large">' + 'Once complete, this page will refresh and the document will become available:' + '</div>' +
			'<div class="speechbubble__paragraph">' + '<img id="imgArchivePending" class="speechbubble__image speechbubble__image--status speechbubble__image--spin" src="' + g_oArchive.g_ArchiveIcons.InProgress + '" />' + '<span style="vertical-align: middle;">Pending</span>' + '</div>' +
			'<div class="speechbubble__paragraph">' + '<img id="imgArchiveProcessing" class="speechbubble__image speechbubble__image--status" src="' + g_oArchive.g_ArchiveIcons.Pending + '" />' + '<span style="vertical-align: middle;">Processing</span>' + '</div>' +
			'<div class="speechbubble__paragraph">' + '<img id="imgArchiveProcessed" class="speechbubble__image speechbubble__image--status" src="' + g_oArchive.g_ArchiveIcons.Pending + '" />' + '<span style="vertical-align: middle;">Processed</span>' + '</div>',
		false);
	},

	/**
	 * Updates the archive info.
	 * @param {string} documentStatus - The document status.
	 */
	updateArchiveInfo: function (documentStatus) {

		// Determine the status.
		switch (documentStatus) {

			// Archived.
			// Pending.
			case "Archived":
			case "Pending":
				$("#imgArchivePending").attr("src", g_oArchive.g_ArchiveIcons.InProgress);
				$("#imgArchivePending").addClass("speechbubble__image--spin");
				$("#imgArchiveProcessing").attr("src", g_oArchive.g_ArchiveIcons.Pending);
				$("#imgArchiveProcessing").removeClass("speechbubble__image--spin");
				$("#imgArchiveProcessed").attr("src", g_oArchive.g_ArchiveIcons.Pending);
				$("#imgArchiveProcessed").removeClass("speechbubble__image--spin");
				break;

			// Processing.
			case "Processing":
				$("#imgArchivePending").attr("src", g_oArchive.g_ArchiveIcons.Complete);
				$("#imgArchivePending").removeClass("speechbubble__image--spin");
				$("#imgArchiveProcessing").attr("src", g_oArchive.g_ArchiveIcons.InProgress);
				$("#imgArchiveProcessing").addClass("speechbubble__image--spin");
				$("#imgArchiveProcessed").attr("src", g_oArchive.g_ArchiveIcons.Pending);
				$("#imgArchiveProcessed").removeClass("speechbubble__image--spin");
				break;

			// Processed.
			case "Processed":
				$("#imgArchivePending").attr("src", g_oArchive.g_ArchiveIcons.Complete);
				$("#imgArchivePending").removeClass("speechbubble__image--spin");
				$("#imgArchiveProcessing").attr("src", g_oArchive.g_ArchiveIcons.Complete);
				$("#imgArchiveProcessing").removeClass("speechbubble__image--spin");
				$("#imgArchiveProcessed").attr("src", g_oArchive.g_ArchiveIcons.Complete);
				$("#imgArchiveProcessed").removeClass("speechbubble__image--spin");
				break;
		}
	},

	/**
	 * Restores the document.
	 */
	restoreDocument: function () {

		// Outline the data for the call.
		var oJSON = {
			oAPICredentials: { SessionId: g_szSessionId },
			DocumentId: g_oArchive.g_ArchiveDocument
		};

		// Restore the document status.
		$.post({
			url: "GreenlightArchive/RestoreDocument",
			data: JSON.stringify(oJSON),
			contentType: "application/json; charset=utf-8",
			dataType: "json",
			cache: false,
			success: function (oResponse) {
				
				// Ensure we are still on the same archive document.
				if (oJSON.DocumentId != g_oArchive.g_ArchiveDocument) {
					return;
				}

				// Check for failures.
				if (!oResponse.Success) {
					return;
				}
			}
		});
	},

	/**
	 * Polls the archive status.
	 */
	pollArchiveStatus: function () {

		// Outline the data for the call.
		var oJSON = {
			oAPICredentials: { SessionId: g_szSessionId },
			DocumentId: g_oArchive.g_ArchiveDocument
		};

		// Restore the document status.
		$.post({
			url: "GreenlightArchive/GetDocumentStatus",
			data: JSON.stringify(oJSON),
			contentType: "application/json; charset=utf-8",
			dataType: "json",
			cache: false,
			success: function (oResponse) {
				
				// Ensure we are still on the same archive document.
				if (oJSON.DocumentId != g_oArchive.g_ArchiveDocument) {
					return;
				}

				// Check for failures.
				if (!oResponse.Success) {
					return;
				}

				// Update the archive information.
				g_oArchive.updateArchiveInfo(oResponse.Contents);

				// If this document is now complete, reload the document.
				if (oResponse.Contents == "Processed") {

					// Unlock and refresh the document.
					setTimeout(function () {

						// Update the status of the restored document.
						var oDocuments = comboControl_GetControlById(g_oArchive.getArchiveControlId(), false).documents;
						for (var i = 0; i < oDocuments.length; i++) {
							if (oDocuments[i].document.documentId == g_oArchive.g_ArchiveDocument) {
								oDocuments[i].document.documentStatus = 2;
								break;
							}
						}

						// Remove the archive lock.
						g_oArchive.removeArchiveLock();

						// Publish the doc change event to reload.
						EventService.publish('changeDoc');
					}, 1000);
					return;
				}

				// Queue up the next poll.
				setTimeout(function () { g_oArchive.pollArchiveStatus(); }, g_oArchive.g_ArchivePollInterval);
			}
		});
	},

	/**
	 * Gets the current archive control id.
	 */
	getArchiveControlId: function () {
		return g_oArchive.g_ArchiveCompareDocument ? "approvalCompareComboControl" : "approvalNameComboControl";
	}
};